if (!customElements.get('jump-links')) {
  customElements.define(
    'jump-links',
    class JumpLinks extends HTMLElement {
      constructor() {
        super();

        this.links = this.querySelectorAll('.jump-links__link');
        this.sections = document.querySelectorAll('.custom-featured-collection');
        this.sectionData = [...this.sections].map((section) => ({ top: section.offsetTop, id: section.id }));
        // Sort sectionData in descending order of top values
        this.sectionData.sort((a, b) => b.top - a.top);
        this.distanceFromTop = this.getDistanceFromTop(this);

        window.addEventListener('scroll', this.handleScroll.bind(this), false);
      }

      getDistanceFromTop(element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        return rect.top + scrollTop;
      }

      handleScroll(e) {
        const OFFSET = 150;
        const scrollY = window.scrollY + OFFSET;
        const activeSection = this.sectionData.find((section) => scrollY >= section.top - OFFSET);

        const amountScrolled = window.scrollY;

        if (amountScrolled > this.distanceFromTop) {
          this.classList.add('jump-links--fixed');
        } else {
          this.classList.remove('jump-links--fixed');
        }

        if (activeSection) {
          this.links.forEach((link) => {
            if (link.href.includes(activeSection.id)) {
              link.classList.add('jump-links__link--active');
            } else {
              link.classList.remove('jump-links__link--active');
            }
          });
        }
      }
    }
  );
}
